import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APIService } from './api.service';
import { ReturnObject } from '../model/returnobject';
import { StatisticsAssignmentConsultant } from '../model/statisticsassignmentconsultant';
import { StatisticsAssignmentNoConsultant } from '../model/statisticsassignmentnoconsultant';
import { RoleGdprItem } from '../model/rolegdpritem';
import { ConsultantGdprItem } from '../model/consultantgdpritem';

@Injectable({
    providedIn: 'root'
})
export class StatisticsService {

    constructor(private api: APIService){
    }

    GetAssignmentConsultants(): Observable<ReturnObject<StatisticsAssignmentConsultant[]>> {
        return this.api.getAPI(`statistics/assignmentconsultant`);
    }

    GetAssignmentNoConsultants(): Observable<ReturnObject<StatisticsAssignmentNoConsultant[]>> {
        return this.api.getAPI(`statistics/assignmentnoconsultant`);
    }

    GetRoleGdpr(globalId: string): Observable<ReturnObject<RoleGdprItem>> {
        return this.api.getAPI(`statistics/gdprrole/${globalId}`);
    }

    GetConsultantGdpr(consultantNumber: string): Observable<ReturnObject<ConsultantGdprItem>> {
        return this.api.getAPI(`statistics/gdprconsultant/${consultantNumber}`);
    }
}
